export default "__VITE_PUBLIC_ASSET__e565bee1__"